import generateFilterConfigs from "../../../utils/FilterConfigGenerator";
import React, { useContext, useEffect, useState } from "react";
import FilterComponent from "../../../components/complex/crud/FilterComponent";
import { Paginator } from "primereact/paginator";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";

import EditorDialog from "./PengecekanMobilOptionsDialog";
import { useDispatch } from "react-redux";
import UiContext from "../../../store/ui-context";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import { DataTable } from "primereact/datatable";
import { SelectButton } from "primereact/selectbutton";
import {
  genTemplateBodyAction,
  genTemplateBodyNumber,
  genTemplateBodyText,
} from "../../../components/utils/TableTemplateBodyGenerator";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import createFilterText from "../../../utils/CreateFilterText";
import { el } from "date-fns/locale";

const title = "Master Opsi Pengecekan";
const fetchOrderBy = "kendaraan_jenis_id";
const fetchOrderMethod = "ASC";
const apiUrl = "pengecekanmobiloption";

const editorDefaultValue = { kode: "", nama: "" };

/**
 * Generate Filter Component
 *
 * available options for type:
 * text_plain
 * number_plain
 * date
 */
const filterConfigs = generateFilterConfigs([
  {
    name: "Jenis",
    field: "kendaraan_jenis_id",
    type: "object",
    object_name: "data_kendaraan_jenis",
    objcet_field: "nama",
    filter: true,
    filter_default: true,
  },
  {
    name: "Urutan",
    field: "urutan",
    type: "number_plain",
    filter: true,
  },
  {
    name: "Status",
    field: "status",
    type: "boolean_plain",
    filter: true,
  },
  {
    name: "Grup Label",
    field: "label_grup",
    type: "text_plain",
    filter: true,
  },
  {
    name: "Keterangan",
    field: "keterangan",
    type: "text_plain",
    filter: true,
  },
]);

const PengecekanMobilOptionPage = (props, { className }) => {
  const uiContext = useContext(UiContext);
  const dispatch = useDispatch();
  const { requestGet, requestGetOne, requestPost, requestDelete, loading } =
    useAPIRequest();

  const { loading: editorLoading, requestPost: editorRequestPost } =
    useAPIRequest();

  const [firstLoad, setFirstLoad] = useState(false);
  const [paging, setPaging] = useState({
    page: 1,
    take: 10,
    filter: "",
    total: 0,
  });
  const [listData, setListData] = useState([]);
  const [listDataJenisKendaraan, setListDataJenisKendaraan] = useState([]);
  const [listDataLabelGroup, setListDataLabelGroup] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [selectedJenisKendaraan, setSelectedJenisKendaraan] = useState(null);

  const [addNewMode, setAddNewMode] = useState(false);
  const [editorData, setEditorData] = useState({});
  const [editorError, setEditorError] = useState({});
  const [editorDialogShowed, setEditorDialogShowed] = useState(false);

  // useEffect section

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
    // fetchListData({ page: 1, take: 10, filter: "" });
    fetchListDataJenisKendaraan({ page: 1, take: 10, filter: "" });
  }, []);

  // API call section

  const fetchListData = async ({ page, take, filter }) => {
    if (loading) return;

    let _filter = filter;
    if (_filter.length > 0) {
      _filter += ";";
    }
    _filter += `utama:>:0;status:=:1`;

    return requestGet({
      fullUrl: `/api/masterdata/${apiUrl}/data`,
      params: {
        page: page,
        take: take,
        filter: _filter,
        order: fetchOrderBy,
        order_method: fetchOrderMethod,
        with_kendaraan_jenis: 1,
      },
      onSuccess: ({ pagination, message, data }) => {
        setPaging({
          ...paging,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: _filter,
        });
        setListData(data);
        const dataLabel = data.map((el) => el.label_grup);
        // remove duplicate in dataLabel
        const dataLabelNoDuplicate = [...new Set(dataLabel)];

        // filter in data

        // for (let i = 0; i < dataLabelNoDuplicate.length; i++) {
        //   newlistData[i] = data.filter((el) => {
        //     return el.label_grup === dataLabelNoDuplicate[i];
        //   });
        // }

        // const newlistData01 = data.filter((el) => {
        //   return el.label_grup === dataLabelNoDuplicate[0];
        // });
        // setListData01(newlistData01);

        // const newlistData01 = listData.filter((el) => {
        //   return listData.indexOf(el.label_group) === dataLabelNoDuplicate[0];
        // });
        // const newlistData01 = listData.label_grup.filter((el, index) => {
        //   return dataLabelNoDuplicate[0] === el;
        // });
        // const newlistData01 = listData.label_group.filter("bagian_depan");
        // setListData01(newlistData01);

        // cara pertama salah
        // let new_data_label = [];
        // dataLabel.forEach((el) => {
        //   new_data_label.forEach((item) => {
        //     if (item !== el) {
        //       new_data_label.push(el);
        //     }
        //   });
        // });

        // cara kedua diperbaiki willi
        // let new_data_label = [];
        // for (let i = 0; i < dataLabel.length; i++) {
        //   const el = dataLabel[i];
        //   let j = 0;
        //   for (; j < new_data_label.length; j++) {
        //     const item = new_data_label[j];
        //     if (el === item) {
        //       break;
        //     }
        //   }
        //   if (j >= new_data_label.length) {
        //     new_data_label.push(el);
        //   }
        // }

        // cara dari willi
        // let new_data_label = [];
        // dataLabel.forEach((el) => {
        //   if (!new_data_label.includes(el)) {
        //     new_data_label.push(el);
        //   }
        // });

        setListDataLabelGroup(dataLabelNoDuplicate);
        // listLabelGroup = dataLabelNoDuplicate;
        // console.log("DATA LABEL", dataLabelNoDuplicate);
        if (!firstLoad) {
          setFirstLoad(true);
        }
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const fetchListDataJenisKendaraan = async ({ page, take, filter }) => {
    if (loading) return;

    return requestGet({
      fullUrl: `/api/masterdata/kendaraanjenis/data`,
      params: {
        page: page,
        take: take,
        filter: "id:>:0",
        order: "id",
        order_method: "ASC",
      },
      onSuccess: ({ pagination, message, data }) => {
        setListDataJenisKendaraan(data);
        if (!firstLoad) {
          setFirstLoad(true);
        }
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const fetchData = async ({ id }) => {
    if (loading) return;
    return requestGetOne({
      fullUrl: `/api/masterdata/${apiUrl}/one/${id}`,
      onSuccess: ({ message, data }) => {},
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const deleteData = async ({ ids }) => {
    if (loading) return;

    return requestDelete({
      fullUrl: `/api/masterdata/${apiUrl}/delete`,
      ids: ids,
      onSuccess: ({ message, data }) => {
        const newListData = listData.filter((el) => !ids.includes(el.id));
        setListData(newListData);
        uiContext.showSuccessMsg("Success", message);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const saveData = async ({ data }) => {
    resetEditorError();
    if (loading) return;
    const valid = validateData();

    if (valid) {
      const body = convertSaveData(data);

      return editorRequestPost({
        fullUrl: `/api/masterdata/${apiUrl}/save`,
        body,
        isForm: false,
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
          setEditorError(data);
        },
        onSuccess: ({ data: responseData, message }) => {
          uiContext.showSuccessMsg("Success", message);
        },
      });
    }
    return null;
  };

  // methods & functions section

  const resetEditorError = () => {
    setEditorError({});
  };

  const validateData = () => {
    let valid = true;

    return valid;
  };

  const convertSaveData = (data) => {
    return data;
  };

  // handle UI events section

  const handleOnReload = async () => {
    setPaging({ ...paging, filter: "" });
    fetchListData({
      page: paging.page,
      take: paging.take,
      filter: "",
    });
  };

  const handleOnFilter = (filterMap) => {
    const filterString = createFilterText(filterMap);
    setPaging({ ...paging, filter: filterString });
    fetchListData({
      page: paging.page,
      take: paging.take,
      filter: filterString,
    });
  };

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    fetchListData({ page: newPage, take: newTake, filter: paging.filter });
  };

  const handleOnDelete = (row) => {
    resetEditorError();
    const accept = async () => {
      if (loading) return;

      await deleteData({ ids: [row.id] });
    };
    const reject = () => {};

    confirmDialog({
      message: "Menghapus 1 data, lanjutkan?",
      header: "Konfirmasi",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept,
      reject,
    });
  };

  const handleDeleteMultiple = () => {
    resetEditorError();

    if (selectedData.length > 0) {
      const accept = async () => {
        if (loading) return;

        const listIds = selectedData.map((el) => el.id);
        await deleteData({ ids: listIds });
        setSelectedData([]);
      };
      const reject = () => {};

      confirmDialog({
        message: `Menghapus ${selectedData.length} data, lanjutkan?`,
        header: "Konfirmasi",
        icon: "pi pi-exclamation-triangle",
        acceptClassName: "p-button-danger",
        accept,
        reject,
      });
    }
  };

  const handleOnAddNew = () => {
    setAddNewMode(true);
    resetEditorError();
    setEditorData({ ...editorDefaultValue });
    setEditorDialogShowed(true);
  };

  const handleOnEdit = async (row) => {
    setAddNewMode(false);
    resetEditorError();
    const newData = await fetchData({ id: row.id });
    if (newData) {
      setEditorData({ ...newData });
      setEditorDialogShowed(true);
    }
  };

  const handleConfirmEditor = async (data) => {
    const newData = await saveData({ data });
    if (newData) {
      if (addNewMode) {
        setListData([newData, ...listData]);
      } else {
        const index = listData.findIndex((el) => el.id === newData.id);
        const newListData = [...listData];
        newListData.splice(index, 1, newData);
        setListData(newListData);
      }
      setEditorDialogShowed(false);
    }
  };

  const handleOnClickJenisKendaraan = (value) => {
    const id = value.id;
    setSelectedJenisKendaraan(value);
    fetchListData({
      page: 1,
      take: 10000,
      filter: `kendaraan_jenis_id:=:${id}`,
    });
    // console.log("newlistData", listData);
  };

  // UI section

  /**
   * Generate Table Column
   *
   * various function to generate
   * genTemplateBodyAction({ row, onEdit, onDelete })
   * genTemplateBodyText({ row, field, defaultEmpty })
   * genTemplateBodyNumber({ row, field, defaultEmpty, maxFraction, minFraction })
   * genTemplateBodyDate({ row, field, format })
   * genTemplateBodyImage({ row, field })
   */
  const actionBodyTemplate = (row) =>
    genTemplateBodyAction({
      row,
      onEdit: (row) => handleOnEdit(row),
      onDelete: handleOnDelete,
    });

  const kendaraanJenisBodyTemplate = (row) =>
    genTemplateBodyText({ row, field: "data_kendaraan_jenis.nama" });
  const urutanBodyTemplate = (row) =>
    genTemplateBodyNumber({ row, field: "urutan" });
  const labelGrupBodyTemplate = (row) =>
    genTemplateBodyText({ row, field: "label_grup" });
  const keteranganBodyTemplate = (row) =>
    genTemplateBodyText({ row, field: "keterangan" });

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <ConfirmDialog />
      <EditorDialog
        data={editorData}
        setData={setEditorData}
        addNewMode={addNewMode}
        loading={editorLoading}
        error={editorError}
        setError={setEditorError}
        visible={editorDialogShowed}
        onHide={() => setEditorDialogShowed(false)}
        onConfirm={handleConfirmEditor}
      />
      {/* <div className="elevated-card-tight-vertical w-100">
        <FilterComponent onFilter={handleOnFilter} configs={filterConfigs} />
      </div> */}
      <div className="elevated-card-tight-vertical row-start-center w-full gap-3">
        <SelectButton
          value={selectedJenisKendaraan}
          onChange={(e) => handleOnClickJenisKendaraan(e.value)}
          optionLabel="nama"
          options={listDataJenisKendaraan}
        />
      </div>
      <div className="elevated-card-tight-vertical row-between-center w-full gap-3">
        <div className="row-start-center gap-2">
          <Button
            icon="pi pi-plus"
            label="Tambah Baru"
            onClick={handleOnAddNew}
          />
          <Button
            disabled={selectedData.length === 0}
            icon="pi pi-trash"
            severity="danger"
            text
            label="Hapus"
            onClick={handleDeleteMultiple}
          />
        </div>
        <div className="row-start-center">
          <Button
            rounded
            outlined
            icon="pi pi-refresh"
            onClick={handleOnReload}
            style={{ width: "40px", height: "40px" }}
          />
        </div>
      </div>

      {/* <div className="elevated-card-tight-vertical row-start-start w-full gap-2 flex-wrap">
        <div className="row-center-center bg-red-100 w-[8rem] h-[5rem]">A</div>
        <div className="row-center-center bg-red-100 w-[8rem] h-[5rem]">B</div>
        <div className="row-center-center bg-red-100 w-[8rem] h-[5rem]">C</div>
        <div className="row-center-center bg-red-100 w-[8rem] h-[5rem]">D</div>
        <div className="row-center-center bg-red-100 w-[8rem] h-[5rem]">E</div>
        <div className="row-center-center bg-red-100 w-[8rem] h-[5rem]">F</div>
        <div className="row-center-center bg-red-100 w-[8rem] h-[5rem]">G</div>
        <div className="row-center-center bg-red-100 w-[8rem] h-[5rem]">H</div>
        <div className="row-center-center bg-red-100 w-[8rem] h-[5rem]">I</div>
        <div className="row-center-center bg-red-100 w-[8rem] h-[5rem]">J</div>
        <div className="row-center-center bg-red-100 w-[8rem] h-[5rem]">K</div>
        <div className="row-center-center bg-red-100 w-[8rem] h-[5rem]">L</div>
      </div> */}

      {listDataLabelGroup.map((el) => {
        return (
          <div
            key={`table-${el}`}
            className="elevated-card col-center-start w-100 gap-3"
          >
            <span className="text-slate-500 font-semibold text-sm">
              {" "}
              {el.toUpperCase().replace("_", " ")}{" "}
            </span>
            <div className={`row-center-center gap-2 w-100`}>
              <DataTable
                dataKey="id"
                className="w-100"
                loading={loading}
                showGridlines
                stripedRows
                editMode="cell"
                value={listData.filter((item) => item.label_grup === el)}
                selection={selectedData}
                onSelectionChange={(e) => setSelectedData(e.value)}
              >
                <Column headerClassName="w-[3rem]" selectionMode={"multiple"} />

                <Column
                  header="Action"
                  alignHeader={"center"}
                  headerClassName="w-[9rem]"
                  body={actionBodyTemplate}
                />
                <Column
                  header="#"
                  headerClassName="w-[5rem]"
                  body={urutanBodyTemplate}
                />
                {/* <Column header="Label Grup" body={labelGrupBodyTemplate} /> */}
                <Column header="Keterangan" body={keteranganBodyTemplate} />
              </DataTable>
            </div>
            {/* <Paginator
              first={parseInt(paging.take) * (paging.page - 1)}
              rows={parseInt(paging.take)}
              totalRecords={parseInt(paging.total)}
              rowsPerPageOptions={[5, 10, 20, 50]}
              onPageChange={handleOnPage}
            /> */}
          </div>
        );
      })}
      <div className="elevated-card col-center-center w-100 gap-3">
        {/* <div className={`row-center-center gap-2 w-100`}>
          <DataTable
            dataKey="id"
            className="w-100"
            loading={loading}
            showGridlines
            stripedRows
            editMode="cell"
            value={listData}
            selection={selectedData}
            onSelectionChange={(e) => setSelectedData(e.value)}
          >
            <Column headerClassName="w-[3rem]" selectionMode={"multiple"} />

            <Column
              header="Action"
              alignHeader={"center"}
              headerClassName="w-[9rem]"
              body={actionBodyTemplate}
            />
            <Column
              header="Jenis Kendaraan"
              headerClassName="w-[10rem]"
              body={kendaraanJenisBodyTemplate}
            />
            <Column
              header="Urutan"
              headerClassName="w-[10rem]"
              body={urutanBodyTemplate}
            />
            <Column header="Label Grup" body={labelGrupBodyTemplate} />
            <Column header="Keterangan" body={keteranganBodyTemplate} />
          </DataTable>
        </div> */}

        {/* <Paginator
          first={parseInt(paging.take) * (paging.page - 1)}
          rows={parseInt(paging.take)}
          totalRecords={parseInt(paging.total)}
          rowsPerPageOptions={[5, 10, 20, 50]}
          onPageChange={handleOnPage}
        /> */}
      </div>
    </div>
  );
};

export default PengecekanMobilOptionPage;
